<template>
  <div class="irp-master-tab" data-testid="irp-master-tab">Account Details</div>
</template>
